module.exports = __webpack_public_path__ + "img/5-1.2d398d37.svg";